var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "task"
  }, [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.tableData,
      bordered: "",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "taskType",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "dataType",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "taskMsg",
      fn: function (text) {
        return [_vm._v(_vm._s(text ? _vm.$t(text) : ""))];
      }
    }, {
      key: "status",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [record.downloadUrl ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onDownload(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下载")))]) : _c("span", [_vm._v("-")])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };